import React from 'react';

import {
  FavoritesListsProvider,
  FavoritedContentProvider,
  CollectionsProvider,
  FavoritesEditProvider
} from './contexts';
import { TvGuideProvider } from './pages/tv-guide/utils/tv-guide-context';
import { SuspendStartOverCancelProvider } from './contexts/suspend-start-over-cancel-context';

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export const AuthenticatedProviders: React.FC<Props> = (props: Props) => {
  const { children } = props;

  return (
    <TvGuideProvider>
      <SuspendStartOverCancelProvider>
        <FavoritesListsProvider>
          <FavoritedContentProvider>
            <FavoritesEditProvider>
              <CollectionsProvider>{children}</CollectionsProvider>
            </FavoritesEditProvider>
          </FavoritedContentProvider>
        </FavoritesListsProvider>
      </SuspendStartOverCancelProvider>
    </TvGuideProvider>
  );
};

export default AuthenticatedProviders;
